<template>
  <div v-cloak class="about">
    <van-search v-model="select_value" placeholder="请输入大神关键词搜索" :clearable="true" @search="do_search" @clear="do_clear"></van-search>
    <van-tabs v-model="activeName" type="card" sticky animated swipeable color="#1aad19">
      <van-tab title="全部" name="all">
        <van-pull-refresh v-model="data_all.is_refresh" @refresh="onRefresh(true)" style="margin-bottom: 50px">
          <van-list class="list-wrap" v-model="data_all.is_loading"
                    :finished="data_all.is_load_finished"
                    :immediate-check="false"
                    finished-text="没有更多了"
                    :error.sync="data_all.is_error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad(tabName.all)">
            <van-cell  v-for="(item, index) in data_all.list" :key="index" v-on:click="go_detail(item.writer_id)" >
              <van-row  type="flex" justify="start" align="ceter">
                <van-col span="4">
                  <writer-avatar shape="circle" :size="48" :writer="item"></writer-avatar>
                </van-col>
                <van-col span="15" >
                  <div class="writer-wrap">
                    <div class="weball-font-14 writer-nickname">{{item.writer_name}}</div>
                    <div class="writer-labels"> <span  v-for="(item, index) in item.labels" :key="index" class="writer-label"
                     :class="['label'+Math.floor(Math.random()*3)]">{{item.text}}</span></div>
                  </div>
                </van-col>
                <van-col span="5">
                  <div class="writer-wrap right">
                    <van-button class="subscripted" hairline v-if="item.is_subscript" color="#888"  plain round type="info" size="small" @click.stop="unsubscript(tabName.all, item.writer_id, index)">
                      取关
                    </van-button>
                    <van-button class="dissubscript" hairline v-else round type="info" size="small"  @click.stop="subscript(tabName.all, item.writer_id, index)">
                      关注
                    </van-button>
                  </div>
                </van-col>
              </van-row>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </van-tab>
      <van-tab title="关注" name="subscript">
        <van-pull-refresh v-model="data_subscript.is_refresh" @refresh="onRefresh(true)" style="margin-bottom: 50px">
          <van-list class="list-wrap" v-model="data_subscript.is_loading"
                    :finished="data_subscript.is_load_finished"
                    :immediate-check="false"
                    finished-text="没有更多了"
                    :error.sync="data_subscript.is_error"
                    error-text="请求失败，点击重新加载"
                    @load="onLoad(tabName.subscript)">
            <van-cell class="list-cell"  v-for="(item, index) in data_subscript.list" :key="index" v-on:click="go_detail(item.writer_id)" >
              <van-row  type="flex" justify="start" align="ceter">
                <van-col span="4">
                  <writer-avatar shape="circle" :size="48" :writer="item"></writer-avatar>
                </van-col>
                <van-col span="15" >
                  <div class="writer-wrap">
                    <div class="writer-nickname">{{item.writer_name}}</div>
                    <div class="writer-labels ">
                      <div  v-for="(item, index) in item.labels" :key="index" class="writer-label" :class="['label'+Math.floor(Math.random()*3)]">{{item.text}}</div>
                    </div>
                  </div>
                </van-col>
                <van-col span="5">
                  <div class="writer-wrap right">
                    <van-button class="subscripted" hairline v-if="item.is_subscript" color="#888"  plain round type="info" size="small" @click.stop="unsubscript(tabName.all, item.writer_id, index)">
                      取关
                    </van-button>
                    <van-button class="dissubscript" hairline v-else round type="info" size="small"  @click.stop="subscript(tabName.all, item.writer_id, index)">
                      关注
                    </van-button>
                  </div>
                </van-col>
              </van-row>
            </van-cell>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>

    <van-tabbar   @change="" route>
      <van-tabbar-item  icon="home-o" replace :to="werouter.index.path">首页</van-tabbar-item>
      <van-tabbar-item  icon="hot-o" replace :to="werouter.author.path">大神</van-tabbar-item>
      <van-tabbar-item  icon="medal-o" replace :to="werouter.match.path">赛事</van-tabbar-item>
      <van-tabbar-item  icon="chat-o" replace :to="werouter.message.path">消息</van-tabbar-item>
      <van-tabbar-item  icon="user-circle-o" replace :to="werouter.mine.path">我的</van-tabbar-item>
    </van-tabbar>
  </div>
</template>
<script>
    import WriterAvatar from "@/views/components/WriterAvatar";
    export default {
        name: 'author',
        components:{
          WriterAvatar
        },
        data() {
            return {
                tabName:{
                  all:'all',
                  subscript:'subscript'
                },
                select_value:'',
                activeName:'all',
                data_all:{
                    page: 0,
                    list: [],
                    is_error: false,
                    is_refresh: false,
                    is_loading: false,
                    is_load_finished: false
                },
                data_subscript:{
                    page: 0,
                    list: [],
                    is_error: false,
                    is_refresh: false,
                    is_loading: false,
                    is_load_finished: false
                }
            }
        },
        created: function () {
            let that = this;
            this.eventbus.$on(this.weconfig.event.subscriptChanged, function (event) {
                this.onRefresh(false)
            }.bind(this))

            this.data_all.page = 1;
            this.getDataAll(this.data_all.page, this.select_value, false)
            this.data_subscript.page = 1;
            this.getDataSubscript(this.data_subscript.page, this.select_value,  false)
        },
        mounted:function(){

        },
        destroyed:function(){
          this.eventbus.$off(this.weconfig.event.subscriptChanged);
        },
        methods: {
            onRefresh(refresh) {
                if(refresh)this.select_value = '';
                this.data_all.page = 1;
                this.getDataAll(this.data_all.page, this.select_value, refresh)
                this.data_subscript.page = 1;
                this.getDataSubscript(this.data_subscript.page, this.select_value,  refresh)
            },
            onLoad(type) {
                if(type === this.tabName.all){
                    this.data_all.page++;
                    this.getDataAll(this.data_all.page, this.select_value, false)
                }
                else  if(type === this.tabName.subscript){
                    this.data_subscript.page++;
                    this.getDataSubscript(this.data_subscript.page, this.select_value,  false)
                }
            },
            getDataAll:function(page,select, refresh){
                let that = this;
                this.weapi.request({
                    url: 'writer_list',
                    method: 'get',
                    params: {page:page,type:this.tabName.all,select:select},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.$toast('刷新成功！');
                            that.data_all.is_refresh = false;
                        }
                        if (that.data_all.page <= 1) {
                            that.data_all.list = [];
                            that.data_all.is_load_finished = false;
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.data_all.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.data_all.is_load_finished = true;
                        }
                    }
                    else {
                        that.data_all.is_refresh = false;
                        that.data_all.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.data_all.is_refresh = false;
                    that.data_all.is_error = true;
                }).finally(function (response) {
                    that.data_all.is_loading = false;
                })
            },
            getDataSubscript:function(page, select, refresh){
                let that = this;
                this.weapi.request({
                    url: 'writer_list',
                    method: 'get',
                    params: {page:page,type:this.tabName.subscript,select:select},
                }).then(res => {
                    if (res.data.code === '200') {
                        let _list = res.data.data.list;
                        if (refresh) {
                            that.$toast('刷新成功！');
                            that.data_subscript.is_refresh = false;
                        }
                        if (that.data_subscript.page <= 1) {
                            that.data_subscript.list = [];
                            that.data_subscript.is_load_finished = false;
                        }
                        for (let i = 0; i < _list.length; i++) {
                            that.data_subscript.list.push(_list[i]);
                        }
                        if (res.data.data.end) {
                            that.data_subscript.is_load_finished = true;
                        }
                    }
                    else {
                        that.data_subscript.is_refresh = false;
                        that.data_subscript.is_error = true;
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                    that.data_subscript.is_refresh = false;
                    that.data_subscript.is_error = true;
                }).finally(function (response) {
                    that.data_subscript.is_loading = false;
                })
            },
            subscript:function(type, writer_id, index){
                if(!this.westore.getters.logined){
                    this.$router.push({ name:  this.werouter.login.name, query: { redirect_name:  this.werouter.author.name,} })
                    return;
                }
                let that = this;
                this.weapi.request({
                    url: 'writer_subscript',
                    method: 'post',
                    params: {writer_id:writer_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        if(type === that.tabName.all){
                            that.data_all.list.splice(index, 1, res.data.data);
                            that.data_subscript.page = 1;
                            that.getDataSubscript(that.data_subscript.page, that.select_value, false)
                        }
                        else if(type === that.tabName.subscript){
                            that.data_subscript.list.splice(index, 1, res.data.data);
                            that.data_all.page = 1;
                            that.getDataAll(this.data_all.page, that.select_value, false)

                        }
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            unsubscript:function(type, writer_id, index){
                if(!this.westore.getters.logined){
                    this.$router.push({ name:  this.werouter.login.name, query: { redirect_name:  this.werouter.author.name,} })
                    return;
                }
                let that = this;
                this.weapi.request({
                    url: 'writer_unsubscript',
                    method: 'post',
                    params: {writer_id:writer_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        if(type === that.tabName.all){
                            that.data_all.list.splice(index, 1, res.data.data);
                            that.data_subscript.page = 1;
                            that.getDataSubscript(that.data_subscript.page, that.select_value, false)
                        }
                        else if(type === that.tabName.subscript){
                            that.data_subscript.list.splice(index, 1);
                            that.data_all.page = 1;
                            that.getDataAll(this.data_all.page, that.select_value, false)
                        }
                    }
                    else {
                        that.$toast(res.data.message);
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            do_search:function(value){
                this.onRefresh(false);
                this.onRefresh(false);
            },
            do_clear:function(res){
                // this.do_search();
            },
            go_detail: function (ID) {
                // if(!this.westore.getters.logined){
                //   this.$router.push({
                //     name: this.werouter.login.name,
                //     query: {redirect_name:this.werouter.author.name}
                //   }).catch(function () {})
                //   return
                // }
                this.$router.push({ name: this.werouter.authordetail.name, params: { writer_id: ID } })
            }
        }
    }
</script>
<style>
  .writer-wrap{
    height: 100%;
    padding: 0 10px 0 0;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: flex-start;
  }
  .writer-wrap.right{
    padding: 0;
    align-items: flex-end;
    margin-right: 1px;
  }
  .writer-labels{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;

  }
  .writer-nickname{
    font-weight: 600;
  }
  .writer-labels .writer-label{
    font-size: 12px;
    padding: 0 5px;
    border-radius: 0 32px 32px 32px;
    line-height: 18px;
    margin-top: 5px;
    margin-right:10px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    max-width: calc(14px * 6);
  }
  .writer-label.label0{
    border: 1px solid #ee0a24;
    color: #ee0a24;
  }
  .writer-label.label1{
    border: 1px solid #1989fa;
    color: #1989fa;
  }
  .writer-label.label2{
    border: 1px solid #ed6a0c;
    color: #ed6a0c;
  }
  .subscripted{
    /*width:64px;*/
    height: 24px;
    padding: 0 8px;
    line-height: 24px;
  }
  .dissubscript{
    /*width:64px;*/
    height: 24px;
    padding: 0 8px;
    line-height: 24px;
  }
</style>
